import AdExchangeComponent from '@/components/common/AdExchangeComponent';
import SymptomResultSection from '@/components/templates/mobile/home/HomeSearchTemplate/components/HomeDiseaseSymptomSearch/components/SymptomResultSection';
import RecentKeyword from '@/components/templates/mobile/home/HomeSearchTemplate/components/RecentKeyword';
import { BannerAdExchangeModel } from '@/models/ad/list';
import { Client } from '@/types/app';
import { HomeSearchKeywordList } from '@/types/search';
import { cn } from '@/utils/style';
import React from 'react';
import styled from 'styled-components';

type Props = {
  entryType?: string;
  popularSymptomList: Array<{
    symptomName: string;
    symptomPublicId: string;
  }>;
  handleSymptomKeywordClick: (keyword: string) => void;
  handleSearchDirectKeyword: (keyword: string) => void;
  recentKeywordViewData: HomeSearchKeywordList;
  handleDeleteItemRecentKeyword: (keyword: string) => void;
  handleDeleteAllRecentKeyword: () => void;
  bannerAdExchange: BannerAdExchangeModel | null;
  client: Client;
  onImpressionAdLog: () => void;
};

const HomeDiseaseSymptomSearch = (props: Props) => {
  const {
    entryType,
    popularSymptomList,
    handleSymptomKeywordClick,
    handleSearchDirectKeyword,
    handleDeleteItemRecentKeyword,
    handleDeleteAllRecentKeyword,
    recentKeywordViewData,
    bannerAdExchange,
    client,
    onImpressionAdLog,
  } = props;

  return (
    <section className={'flex flex-col gap-[16px] bg-white'}>
      {entryType !== 'symptom' && recentKeywordViewData.length > 0 && (
        <RecentKeyword
          onSearchDirectKeyword={handleSearchDirectKeyword}
          recentKeywordViewData={recentKeywordViewData}
          onDeleteItemRecentKeyword={handleDeleteItemRecentKeyword}
          onDeleteAllRecentKeyword={handleDeleteAllRecentKeyword}
          hasAdExchage={!!bannerAdExchange}
        />
      )}
      <AdExchangeComponent fallback={null} bannerAdExchange={bannerAdExchange} onImpressionLog={onImpressionAdLog}>
        <AdExchangeComponent.Content className={'px-[24px]'}>
          <AdExchangeComponent.ImageAd
            className={cn('w-full rounded-[8px]', {
              'aspect-[720/80]': !client.isMobile,
              'aspect-[312/80]': client.isMobile,
            })}
          />
          <AdExchangeComponent.DeliberatedCode />
        </AdExchangeComponent.Content>
      </AdExchangeComponent>
      <SymptomResultSection title={'인기 검색어'}>
        <SymptomResultSection.Result>
          <PopularSearchSymptomKeywordContainer>
            {popularSymptomList.map((symptom: { symptomName: string; symptomPublicId: string }, index: number) => {
              return (
                <PopularSearchSymptomKeyword
                  key={symptom.symptomPublicId}
                  onClick={() => handleSymptomKeywordClick(symptom.symptomName)}
                >
                  <PopularSearchSymptomKeywordIndex>{index + 1}</PopularSearchSymptomKeywordIndex>
                  <PopularSearchSymptomKeywordContent>{symptom.symptomName}</PopularSearchSymptomKeywordContent>
                </PopularSearchSymptomKeyword>
              );
            })}
          </PopularSearchSymptomKeywordContainer>
        </SymptomResultSection.Result>
      </SymptomResultSection>
    </section>
  );
};

export default HomeDiseaseSymptomSearch;

const PopularSearchSymptomKeywordContainer = styled.div`
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 24px 16px;
  margin: 0;
`;

const PopularSearchSymptomKeyword = styled.button`
  border: none;
  width: 100%;
  padding: 8px 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
const PopularSearchSymptomKeywordIndex = styled.span`
  color: ${({ theme }) => theme.color.primary700};
  ${({ theme }) => theme.typography.UI15SB};
  display: flex;
  text-align: left;
  width: 20px;
  height: 20px;
  align-items: center;
`;

const PopularSearchSymptomKeywordContent = styled.span`
  color: ${({ theme }) => theme.color.gray700};
  ${({ theme }) => theme.typography.UI17SB};
  display: inline-flex;
  align-items: center;
  height: 30px;
  margin-left: 8px;
  text-align: left;
`;
